<template>
  <div class="podcasts">
    <PodcastActions
      :podcast="podcast"
      @save="savePodcast"
      @delete="deletePodcast"
    />
    <PodcastNav :podcast-id="$route.params.id" />

    <router-view
      @dirty="dirty = true"
      @clean="dirty = false"
      ref="view"
    ></router-view>
  </div>
</template>

<script>
import PodcastNav from '@/components/PodcastNav'
import PodcastActions from '@/components/PodcastActions'
import CHECK_PODCAST from '@/graphql/CheckPodcast.gql'
import DELETE_PODCAST from '@/graphql/DeletePodcast.gql'
import GET_FOLDER_DATA from '@/graphql/GetFolderData.gql'
import { validateAndStoreResource } from '@/utils'

export default {
  components: {
    PodcastNav,
    PodcastActions,
  },

  beforeRouteEnter: validateAndStoreResource({
    query: to => ({
      query: CHECK_PODCAST,
      variables: { id: to.params.id },
    }),
    validate: res => res.data.findPodcastByID,
    store: (res, vm) => vm.setData(res.data.findPodcastByID),
  }),

  data() {
    return {
      podcast: {
        _id: this.$route.params.id,
        name: '',
      },
      dirty: false,
    }
  },

  methods: {
    setData(data) {
      this.podcast = data
      this.$store.commit('podcast/setCurrentPodcast', data)
    },

    deletePodcast() {
      if (
        confirm(`Cancellare definitivamente il podcast ${this.podcast.name}?`)
      ) {
        this.$store.commit('podcast/setDeleteLoading', true)
        this.$apollo
          .mutate({
            mutation: DELETE_PODCAST,
            variables: { id: this.podcast._id },
            update(store, res) {
              const query = {
                query: GET_FOLDER_DATA,
                variables: {
                  id: res.data.deletePodcast.folder._id,
                },
              }
              const data = store.readQuery(query)

              const index = data.findFolderByID.podcasts.data.findIndex(
                p => p._id === res.data.deletePodcast._id,
              )
              if (index >= 0) {
                data.findFolderByID.podcasts.data.splice(index, 1)
                store.writeQuery({
                  ...query,
                  data,
                })
              }
            },
          })
          .then(res => {
            this.$router.push({
              name: 'Folders',
              params: {
                id: res.data.deletePodcast.folder._id,
                tenant: this.$route.params.tenant,
              },
            })
            this.$store.commit('podcast/setDeleteLoading', false)
          })
          .catch(err => {
            console.log(err)
          })
      }
    },

    savePodcast() {
      // this.$store.dispatch('podcast/update')
      this.$refs.view.$refs.section.validateAndSubmit()
    },
  },
}
</script>

<style lang="scss" scoped></style>
